import * as types from '../actions/actionTypes';

let initialState = {
    organizations: {
        loading: false,
        success: true,
        data: []
    },
    filters: {
        keyword: '',
        recipientSearch: '',
        firstName: '',
        lastName: '',
        reportName: '',
        teudatZahut: '',
        phoneNumber: '',
        categories: [],
        nationalities: [],
        recipientTypes: [],
        recipientStatuses: [],
        references: [],
        organizations: [],
        taxId: '',
        streetNames: [],
        cities: [],
        hasPledges: false,
        incomplete: false,
        campaignLists: [],
        bankAccount: ''
    },
    createRecipient: {
        loading: false,
        success: false,
        data: ''
    },
    export: {
        loading: false,
        success: false,
        data: ''
    }
};

export default function recipientAccountsReducer(state = initialState, action) {
    switch (action.type) {
        case types.START_GET_ORGANIZATIONS:
            return Object.assign({}, state, { organizations: { ...state.organizations, success: true, loading: true } });
        case types.GET_ORGANIZATIONS:
            return Object.assign({}, state, { organizations: action.response });

        case types.UPDATE_RECIPIENTS_FILTERS:
            return Object.assign({}, state, { filters: { ...state.filters, ...action.update } });
        case types.RESET_RECIPIENTS_FILTERS:
            return Object.assign({}, state, { filters: initialState.filters });

        case types.START_CREATE_RECIPIENT:
            return { ...state, createRecipient: { ...initialState.createRecipient, loading: true } };
        case types.CREATE_RECIPIENT:
            return { ...state, createRecipient: { ...action.response } };

        case types.GET_RECIPIENTS_FOR_EXPORT:
            return Object.assign({}, state, { export: { ...action.response }})

        case types.START_GET_PLEDGES_REPORT:
            return Object.assign({}, state, { pledgeReport: { ...state.pledgeReport, loading: true, success: true } });
        case types.GET_PLEDGES_REPORT:
            return Object.assign({}, state, { pledgeReport: { ...action.response }})

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/RecipientAccountsReducer.js